import { createSlice } from '@reduxjs/toolkit';
import FJConstant from '../../constants/FJConstant';
import { STYLE_LIST } from '../../config/dataConfig/FJImageToImageData';
import FJUtil from '../../util/FJUtil';

const __defaultStyle = () => {
    const recId = FJUtil.getQueryString(FJConstant.REC_ID);
    const recIdInfo = recId ? JSON.parse(window.localStorage.getItem(recId)) : null;
    const hasStyle = !!STYLE_LIST.find(ca => ca.list.find(item => item.value === recIdInfo?.style));
    return hasStyle ? recIdInfo?.style : STYLE_LIST[0].list[0].value;
};
export const FJSliceImageToImage = createSlice({
    name: 'imageToImage',
    initialState: {
        uploadImageInfo: {},
        prompt: '',
        selectStyleCategory: 0,
        selectedStyle: __defaultStyle(),
        generateQuantity: 2,
    },
    reducers: {
        setSliceUploadImageInfoAction: (state, action) => {
            state.uploadImageInfo = action.payload;
        },
        setSlicePromptAction: (state, action) => {
            state.prompt = action.payload;
        },
        setSliceSelectStyleCategoryAction: (state, action) => {
            state.selectStyleCategory = action.payload;
        },
        setSliceSelectedStyleAction: (state, action) => {
            state.selectedStyle = action.payload;
        },
        setSliceGenerateQuantityAction: (state, action) => {
            state.generateQuantity = action.payload;
        },
    },
});

export const {
    setSliceUploadImageInfoAction,
    setSlicePromptAction,
    setSliceSelectStyleCategoryAction,
    setSliceSelectedStyleAction,
    setSliceGenerateQuantityAction,
} = FJSliceImageToImage.actions;

export default FJSliceImageToImage.reducer;
